import React, { useEffect, useState } from 'react'
import { Property } from '../../../../types/Property/Property'
import {
  formatCurrency,
  formatPercentage,
} from '../../../../lib/utils/formatNumber'
import { HeroIcons } from '../../../../lib/utils/heroIcons'
import { useTranslation } from 'next-i18next'
import useCurrency from '../../../../hooks/useCurrency'
import useLocale from '../../../../hooks/useLocale'

type ProjectSectionProps = {
  className?: string
  property: Property
}

export default function ProjectSection({
  className,
  property,
}: ProjectSectionProps) {
  const { t } = useTranslation('originals/property')
  const { currency } = useCurrency()
  const { locale } = useLocale()
  const [projectDescription, setProjectDescription] = useState<string>()
  const [projectDetails, setProjectDetails] = useState<any[]>([])

  // let projectDetails =

  useEffect(() => {
    if (!property) return

    setProjectDescription(
      property.translation.descriptions?.projectDetails?.description ?? '',
    )

    let _projectDetails = [
      {
        name: t('projectSection.projectDetails.totalBudget'),
        content: `${formatCurrency(
          property.fractionCount * property.fractionInitialPrice || 0,
          0,
          2,
          currency,
          locale,
        )}`,
        icon: HeroIcons.WalletIcon,
      },
      {
        name: t('projectSection.projectDetails.netRentalYields'),
        content: `${formatPercentage(property.rentalYieldPerYear || 0, 2, true)}`,
        icon: HeroIcons.BanknotesIcon,
      },
    ]

    if (property.revaluationPerYear > 0) {
      _projectDetails.push({
        name: t('projectSection.projectDetails.propertyReassessmentHistory'),
        content: `${formatPercentage(property.revaluationPerYear, 2, true)}`,
        icon: HeroIcons.ChartBarIcon,
      })
    }
    setProjectDetails(_projectDetails)
  }, [currency, locale, property, t])

  return (
    <div className={className}>
      <div className="border-b-[1px] border-dashed border-neutralGray/50 pb-4">
        <div className="text-justify text-sm font-thin text-neutralBlack">
          {projectDescription}
        </div>

        <div className="mt-4">
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            {projectDetails.slice(0, 1).map((p) => (
              <div
                key={p.name}
                className="border-1 rounded-2xl border-brandLightBlue bg-brandLightBlue p-4"
              >
                <p.icon className="mb-2 h-8 w-8 text-neutralWhite" />
                <div className="text-3xl text-neutralWhite">{p.content}</div>
                <div className="font-thin text-neutralWhite">{p.name}</div>
              </div>
            ))}
            {projectDetails.slice(1).map((p) => (
              <div
                key={p.name}
                className="border-1 rounded-2xl border-brandLightBlue bg-neutralWhite p-4"
              >
                <p.icon className="mb-2 h-8 w-8 text-brandLightBlue" />
                <div className="text-3xl text-brandLightBlue">{p.content}</div>
                <div className="font-thin text-neutralBlack">{p.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-4">
        <div className="pb-2 font-bold text-neutralBlack">
          {t('projectSection.rentalPotential.title')}
        </div>
        <div className="border-1 rounded-2xl border-supportingYellow bg-supportingYellow/10 p-4">
          <HeroIcons.HomeIcon className="mb-2 h-9 w-9 text-neutralBlack" />
          <div className="text-justify text-sm font-thin text-neutralBlack">
            {t('projectSection.rentalPotential.disclaimer')}
          </div>
        </div>
        {/*<div className="mt-4 text-justify text-white">
          <div className="text-sm font-bold text-neutralBlack">
            {t('projectSection.rentalPotential.canBeRented')}
          </div>
          <div className="text-sm font-thin text-neutralBlack">
            {formatCurrency(94300, 0, true, currency, locale)}{' '}
            {t('projectSection.rentalPotential.VAT')}/
            {t('projectSection.rentalPotential.month')}
          </div>
        </div>*/}
      </div>
    </div>
  )
}
